import "../assetCategories/AssetCategoriesForm.scss";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { BeatLoader } from "react-spinners";
import newRequest from "../../../utils/newRequest";
import CustomSnakebar from "../../../utils/CustomSnakebar";
import { useTranslation } from "react-i18next";

const UpdateDepartmentForm = ({ inputs, title }) => {
  const { t } = useTranslation();
  const { id } = useParams();
  const navigate = useNavigate();
  const [formValues, setFormValues] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(false);
  const [message, setMessage] = useState("");

  useEffect(() => {
    // Try to use selectedRow from table (contains full record)
    const selectedRow = JSON.parse(sessionStorage.getItem("selectedRow"));
    if (selectedRow && String(selectedRow.DAONumber) === String(id)) {
      setFormValues({
        branchcode: selectedRow.branchcode ?? "",
        DAONumber: selectedRow.DAONumber ?? id ?? "",
        BusinessUnit: selectedRow.BusinessUnit ?? "",
        BUSINESSGROUP: selectedRow.BUSINESSGROUP ?? "",
        HRMapping: selectedRow.HRMapping ?? "",
        DaoName: selectedRow.DaoName ?? "",
        DaoArea: selectedRow.DaoArea ?? "",
      });
      return;
    }

    // Fallback to API fetch by DAONumber
    newRequest
      .post("/GetNewDepartmentLitById", { DAONumber: id })
      .then((response) => {
        const record =
          response?.data?.recordset?.[0] ??
          response?.data?.recordsets?.[0]?.[0] ??
          {};
        setFormValues({
          branchcode: record.branchcode ?? "",
          DAONumber: record.DAONumber ?? id ?? "",
          BusinessUnit: record.BusinessUnit ?? "",
          BUSINESSGROUP: record.BUSINESSGROUP ?? "",
          HRMapping: record.HRMapping ?? "",
          DaoName: record.DaoName ?? "",
          DaoArea: record.DaoArea ?? "",
        });
      })
      .catch((err) => {
        setError(err?.response?.data?.message ?? "Failed to load");
      });
  }, [id]);

  const resetSnakeBarMessages = () => {
    setError(null);
    setMessage(null);
  };

  const handleSubmit = async (event) => {
    if (!event.target.checkValidity()) return;
    event.preventDefault();
    setIsLoading(true);
    try {
      const data = {
        branchcode: formValues.branchcode,
        DAONumber: formValues.DAONumber ?? id,
        BusinessUnit: formValues.BusinessUnit,
        BUSINESSGROUP: formValues.BUSINESSGROUP,
        HRMapping: formValues.HRMapping,
        DaoName: formValues.DaoName,
        DaoArea: formValues.DaoArea,
      };
      await newRequest.put("/UpdateNewDepartmentLitById", data);
      setMessage(t("Successfully Updated") || "Successfully Updated");
    } catch (err) {
      setError(err?.response?.data?.message ?? "Failed to Update");
    } finally {
      setIsLoading(false);
    }
  };

  const handleInputChange = (event, inputName) => {
    setFormValues({ ...formValues, [inputName]: event.target.value });
  };

  return (
    <>
      {isLoading && (
        <div
          className="loading-spinner-background"
          style={{
            zIndex: 9999,
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(255, 255, 255, 0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <BeatLoader size={18} color="#6439ff" loading={isLoading} />
        </div>
      )}
      <span>
        {message && (
          <CustomSnakebar
            message={message}
            severity="success"
            onClose={resetSnakeBarMessages}
          />
        )}
        {error && (
          <CustomSnakebar
            message={error}
            severity="error"
            onClose={resetSnakeBarMessages}
          />
        )}
        <div className="assetCategoryForm">
          <div className="newContainer">
            <div className="top">
              <span className="topSpan">
                <h1>{title}</h1>
                <button type="button" onClick={() => navigate(-1)}>
                  {t("Go Back")}
                </button>
              </span>
            </div>
            <div className="bottom">
              <div className="right">
                <form onSubmit={handleSubmit} id="departmentUpdateForm">
                  {inputs.map((input) => (
                    <div className="formInput" key={input.id}>
                      <label htmlFor={input.name}>{input.label}</label>
                      <input
                        type={input.type || "text"}
                        placeholder={input.placeholder}
                        name={input.name}
                        id={input.name}
                        required={input.isFieldRequired}
                        value={formValues[input.name] ?? ""}
                        onChange={(e) => handleInputChange(e, input.name)}
                        readOnly={input.name === "DAONumber"}
                      />
                    </div>
                  ))}
                  <div className="buttonAdd">
                    <button type="submit">
                      {t("Update")} {t("Department")}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </span>
    </>
  );
};

export default UpdateDepartmentForm;

